import { render, staticRenderFns } from "./newpage4.vue?vue&type=template&id=6086ec1c&scoped=true&"
import script from "./newpage4.vue?vue&type=script&lang=js&"
export * from "./newpage4.vue?vue&type=script&lang=js&"
import style0 from "./newpage4.vue?vue&type=style&index=0&id=6086ec1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6086ec1c",
  null
  
)

export default component.exports